import { render } from "./AddOptionGroup.vue?vue&type=template&id=6c689bb6&scoped=true"
import script from "./AddOptionGroup.vue?vue&type=script&lang=js"
export * from "./AddOptionGroup.vue?vue&type=script&lang=js"

import "./AddOptionGroup.vue?vue&type=style&index=0&id=6c689bb6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c689bb6"]])

export default __exports__